
import store from '../../store';
import Vue from 'vue';

const success = (data, resolve) => {
  const widgetsData = data;
  store.dispatch('fetchWidgets', widgetsData);
  resolve();
};

const failed = (error, reject) => reject(error);

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('user-widgets')
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/widgets/fetchUserWidgets.js